import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {PermissionsService} from "../../../../services/permissions/permissions.service";

@Component({
  selector: 'app-org-edit-user-modal',
  templateUrl: './org-edit-role-modal.component.pug',
  styleUrls: ['./org-edit-role-modal.component.scss'],
  standalone: false
})
export class OrgEditRoleModalComponent implements OnInit {
  public nextClick: EventEmitter<any> = new EventEmitter<any>()
  @Input() data!: any;
  title = $localize`User role`;
  userRoleSelected!: string;
  name = '';
  disableSend = false;
  setToOwner = true;

  constructor(public _bsModalRef: BsModalRef,
              private permissions: PermissionsService) {
  }

  ngOnInit(): void {
    this.userRoleSelected = this.data.role;
    if (this.data.isUserEdit) {
      this.name = this.data.first_name + ' ' + this.data.last_name;
    } else {
      this.name = this.data.email;
    }
    if ("user_uid" in this.data) {
      if (!this.permissions.hasUserOrgPermission('set_others_user_role')) {
        this.disableSend = true;
      }
      if (!this.permissions.hasUserOrgPermission('set_user_to_owner')) {
        this.setToOwner = false;
      }
    }
  }

  cancel() {
    this._bsModalRef.hide();
  }

  roleOfUser($event) {
    if ($event !== this.data.role) this.userRoleSelected = $event;
  }

  save() {
    let payload = {};
    if (this.data.isUserEdit) {
      payload = {
        role: this.userRoleSelected
      }
    } else {
      payload = {
        email: this.data.email,
        role: this.userRoleSelected
      }
    }
    let data = {
      "payload": payload,
      "isUserEdit": this.data.isUserEdit
    }
    this.nextClick.emit({data: data})
    this._bsModalRef.hide();
  }

}
